import ApiService from "../../../commons/api/api_service";
import BaseResponse from "../../../commons/api/base_response";
import { Endpoints } from "../../../commons/api/endpoints";
import { ProviderVM } from "../../../commons/base/providers/view_model";
import { ShowSnackbarModel } from "../../../commons/scaffold/scaffold";
import MenuPackagingRequest from "../models/menu_packaging_request";
import MenuPackagingResponse, { MenuModel, MenuToPackagingModel } from "../models/menu_packaging_response";

export default class MenuPackagingViewModel extends ProviderVM {
    isFilter: boolean = false;
    isLoading: boolean = true;
    isShowModal: boolean = false;
    filteredItems: MenuToPackagingModel[] = [];
    items: MenuToPackagingModel[] = [];
    itemsMenu: MenuModel[] = [];
    itemsMenuAll: MenuModel[] = [];
    itemsMenuNoPackaging: MenuModel[] = [];
    itemsPackaging: MenuModel[] = [];
    errorMessage: string = "";
    errorSnackBar?: ShowSnackbarModel;
    searchQuery: string = "";
    selectedId: number = 0;
    selectedItemId: number = 0;
    selectedPackagingId: number = 0;
    selectedQuantity: number = 1;

    constructor() {
        super();
        this.loadData();
        this.onSelectItemChange = this.onSelectItemChange.bind(this);
        this.onSelectPackagingChange = this.onSelectPackagingChange.bind(this);
        this.onInputQuantityChange = this.onInputQuantityChange.bind(this);
    }

    get selectedDetail() {
        const getDetail = this.items.find(
            (item) => item.id === this.selectedId
        );

        return getDetail;
    }

    clearFilter() {
        this.emit(() => {
            this.isFilter = false;
            this.filteredItems = [];
            this.searchQuery = "";
        });
    }

    closeDetail() {
        this.emit(() => {
            this.isShowModal = false;
            this.selectedId = 0;
            this.selectedItemId = 0;
            this.selectedPackagingId = 0;
            this.selectedQuantity = 1;
            this.errorSnackBar = undefined;
        });
    }

    deleteMenuPackaging(id: number) {
        ApiService.fetch<{id: number}, BaseResponse<{}>>(
            Endpoints.inventoryDeleteMenuPackaging,
            {
                parameters: {
                    id: id
                },
                onSuccess: (response) => {
                    console.log("Finish delete");
                    if (response.code === 200) {
                        this.emit(() => {
                            this.errorSnackBar = undefined;
                            this.isFilter = false;
                        });
                        this.loadData();
                    } else {
                        this.emit(() => {
                            this.errorSnackBar = new ShowSnackbarModel({
                                message: response.message,
                                type: "error"
                            });
                        })
                    }
                }, 
                onFailure: (error) => {
                    console.log("Failed delete");
                    this.emit(() => {
                        this.errorSnackBar = new ShowSnackbarModel({
                            message: "Gagal menghapus item",
                            type: "error"
                        });
                    })
                }
            }
        )
    }

    getItemMenuWithNoPackaging() {
        const itemIdHadPackaging = this.items.map(item => { return item.itemId });
        return this.itemsMenuAll.filter(item => { return !itemIdHadPackaging.includes(item.id) });
    }

    loadData() {
        this.emit(() => {
            this.isLoading = true;
            this.errorMessage = "";
            this.errorSnackBar = undefined;
            this.selectedId = 0;
            this.selectedItemId = 0;
            this.selectedPackagingId = 0;
            this.selectedQuantity = 1;
        });

        ApiService.fetch<{}, BaseResponse<MenuPackagingResponse>>(
            Endpoints.inventoryGetMenuPackaging,
            {
                onSuccess: (response) => {
                    console.log("success")
                    console.log(response.data);
                    this.emit(() => {
                        this.isLoading = false;
                        this.items = response.data?.menuToPackaging ?? [];
                        this.itemsMenuAll = response.data?.menuItems ?? [];
                        this.itemsPackaging = response.data?.menuPackagings ?? [];
                    });
                },
                onFailure: (error) => {
                    console.log("error")
                    this.emit(() => {
                        this.errorMessage = `${error}`;
                        this.isLoading = false;
                    });
                },
            }
        );
    }

    loadBlankDetail() {
        this.emit(() => {
            this.isShowModal = true;
            this.itemsMenu = this.getItemMenuWithNoPackaging();
        });
    }

    loadDetail(id: number, itemId: number, packagingId: number, quantity: number) {
        const itemsMenu = this.getItemMenuWithNoPackaging();
        const itemMenuSelected = this.itemsMenuAll.filter(item => { return item.id === itemId });
        itemsMenu.push(itemMenuSelected[0]);
        this.emit(() => {
            this.isShowModal = true;
            this.itemsMenu = itemsMenu;
            this.selectedId = id;
            this.selectedItemId = itemId;
            this.selectedPackagingId = packagingId;
            this.selectedQuantity = quantity;
        });
    }

    onInputQuantityChange(id: number, quantity: number) {
        this.emit(() => {
            this.selectedId = id;
            this.selectedQuantity = quantity;
        });
    }

    onSelectItemChange(id: number, itemId: number) {
        this.emit(() => {
            this.selectedId = id;
            this.selectedItemId = itemId;
        });
    }

    onSelectPackagingChange(id: number, packagingId: number) {
        this.emit(() => {
            this.selectedId = id;
            this.selectedPackagingId = packagingId;
        });
    }

    retryAction() {
        this.loadData();
    }

    setSearchQuery(value: string) {
        this.emit(() => {
            this.searchQuery = value;
        });
    }

    searchItems() {
        this.emit(() => {
            this.errorMessage = "";
            this.isFilter = true;
        });

        this.filteredItems = this.items.filter(item => {
            return item.itemName.toLowerCase().includes(this.searchQuery.toLowerCase().trim());
        });
    }

    submit() {
        const isCreateNew = this.selectedId === 0;
        const data = {
            id: isCreateNew ? undefined : this.selectedId,
            itemId: this.selectedItemId,
            packagingId: this.selectedPackagingId,
            quantity: this.selectedQuantity === 0 ? 1 : this.selectedQuantity
        }
        const URL = isCreateNew ? Endpoints.inventoryCreateMenuPackaging : Endpoints.inventoryEditMenuPackaging;
        ApiService.fetch<MenuPackagingRequest, BaseResponse<{}>>(
            URL,
            {
                parameters: data,
                onSuccess: (response) => {
                    if (response.code === 200) {
                        console.log("success submit")
                        this.emit(() => {
                            this.isLoading = false;
                            this.isShowModal = false;
                            this.errorSnackBar = undefined;
                        });
                        this.loadData();
                    } else {
                        console.log("error submit")
                        this.emit(() => {
                            // this.errorMessage = response.message;
                            this.isLoading = false;
                            this.errorSnackBar = new ShowSnackbarModel({
                                message: response.message,
                                type: "error"
                            });
                        });
                    }
                },
                onFailure: (error) => { 
                    console.log("error submit")
                    this.emit(() => {
                        this.errorMessage = `${error}`;
                        this.isLoading = false;
                    });
                },
            }
        );

    }
}